var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initCollectionCard = /* @__PURE__ */ __name(($el, $refs, collectionHandle) => {
  var _a, _b;
  const random_id = utils.shortUUID();
  const collection = _collections[collectionHandle] || utils.JSONParse((_a = document.querySelector(`[data-collection-data="${collectionHandle}"]`)) == null ? void 0 : _a.innerHTML);
  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...collection != null ? collection : {},
    url: (_b = collection == null ? void 0 : collection.url) != null ? _b : `/collection/${collection == null ? void 0 : collection.handle}`
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    var _a2;
    return (_a2 = content.split(",")) == null ? void 0 : _a2.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels
  };
}, "initCollectionCard");
const hydrateCollectionCard = /* @__PURE__ */ __name(($el, card_handle, collection_handle, collection_id, classes = []) => {
  const hydrateCollectionCardContent = /* @__PURE__ */ __name(() => {
    var _a;
    const node = (_a = document.querySelector(`[data-collection-card='${card_handle}']`)) == null ? void 0 : _a.cloneNode(true);
    if (!node && !$el.hasAttribute("data-intersected")) {
      $el.setAttribute("data-intersected", "true");
      const mo = new MutationObserver((mutation, obs) => {
        var _a2;
        if ($el.hasAttribute("data-cards-loaded")) {
          $el.removeAttribute("data-intersected");
          const node2 = (_a2 = document.querySelector(`[data-collection-card='${card_handle}']`)) == null ? void 0 : _a2.cloneNode(true);
          if (node2 && $el && $el.parentNode) {
            node2 == null ? void 0 : node2.removeAttribute(`data-collection-card`);
            node2 == null ? void 0 : node2.setAttribute("data-collection-handle", collection_handle);
            node2 == null ? void 0 : node2.setAttribute("data-collection-id", collection_id);
            node2.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
              el.remove();
            });
            node2.classList.add(...classes);
            $el.parentNode.replaceChild(node2, $el);
          }
          mo.disconnect();
          observer.disconnect();
        }
      });
      mo.observe($el, { attributes: true });
      return;
    }
    if (node && $el && $el.parentNode) {
      node == null ? void 0 : node.removeAttribute(`data-collection-card`);
      node == null ? void 0 : node.setAttribute("data-collection-handle", collection_handle);
      node == null ? void 0 : node.setAttribute("data-collection-id", collection_id);
      node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
        el.remove();
      });
      node.classList.add(...classes);
      $el.parentNode.replaceChild(node, $el);
    }
  }, "hydrateCollectionCardContent");
  if ($el.hasAttribute("data-intersected")) {
    hydrateCollectionCardContent();
    return;
  }
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        hydrateCollectionCardContent();
        observer.disconnect();
      }
    },
    { rootMargin: "300px 300px 300px 300px" }
  );
  observer.observe($el);
}, "hydrateCollectionCard");
window._sections["initCollectionCard"] = initCollectionCard;
window._sections["hydrateCollectionCard"] = hydrateCollectionCard;
